//#region src/lib/exclusion_rules.js
function areConditionsMet(rule, propValues) {
	return Object.entries(rule.when).every(([prop, condition]) => typeof condition === "function" ? condition(propValues[prop]) : condition === propValues[prop]);
}
/**
* Determines if a member should be excluded (hidden) based on exclusion rules
* and the current prop values.
*
* @param {string} memberName - The name of the member to check.
* @param {string} memberGroup - The member group ('props' or 'slots').
* @param {Array} exclusionRules - Array of exclusion rule objects.
* @param {object} propValues - Current prop values.
* @returns {boolean} Whether the member should be excluded.
*/
function shouldExclude(memberName, memberGroup, exclusionRules, propValues) {
	if (!exclusionRules?.length) return false;
	return exclusionRules.some((rule) => {
		if (!areConditionsMet(rule, propValues)) return false;
		return rule.hide?.[memberGroup]?.includes(memberName) ?? false;
	});
}
/**
* Collects disabled values for a specific prop based on exclusion rules
* and the current prop values.
*
* @param {string} propName - The prop to check for disabled values.
* @param {Array} exclusionRules - Array of exclusion rule objects.
* @param {object} propValues - Current prop values.
* @returns {Set} Set of disabled value strings.
*/
function getDisabledValues(propName, exclusionRules, propValues) {
	const disabled = /* @__PURE__ */ new Set();
	if (!exclusionRules?.length) return disabled;
	for (const rule of exclusionRules) {
		if (!areConditionsMet(rule, propValues)) continue;
		const values = rule.disableValues?.props?.[propName];
		if (values) values.forEach((v) => disabled.add(String(v)));
	}
	return disabled;
}
//#endregion
export { getDisabledValues, shouldExclude };

//# sourceMappingURL=exclusion_rules.js.map